import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import DateSpan from 'components/Presentation/Dates/DateSpan';
import ResizeObserver from 'react-resize-aware';
import { translate } from '@haldor/ui';
import { ColorLabel, ColorLabelContainer } from 'UI';
import { Minus, Plus } from 'UI/Icons';
var ReactGantt = /*#__PURE__*/function (_Component) {
  function ReactGantt(props) {
    var _this;
    _classCallCheck(this, ReactGantt);
    _this = _callSuper(this, ReactGantt, [props]);
    _defineProperty(_this, "getCalculatedStyles", function (row) {
      var difference = moment(_this.props.options.leftBound).unix();
      var rightBound = moment(_this.props.options.rightBound).unix() - difference;
      var startDate = moment(row.startDate).unix() - difference;
      if (startDate < 0) {
        startDate = 0;
      } else if (startDate > rightBound) {
        startDate = rightBound;
      }
      var climaxDate = moment(row.climaxDate).unix() - difference;
      if (climaxDate < 0) {
        climaxDate = 0;
      } else if (climaxDate > rightBound) {
        climaxDate = rightBound;
      }
      var endDate = moment(row.endDate).unix() - difference;
      if (endDate < 0) {
        endDate = 0;
      } else if (endDate > rightBound) {
        endDate = rightBound;
      }
      var leftPadWidth = "".concat(startDate / rightBound * 100, "%");
      var div2Width = (endDate - startDate) / rightBound * 100;
      var rightPadWidth = "".concat((rightBound - endDate) / rightBound * 100, "%");
      var div2BackgroundColor = 'red';
      if (row.afterClimaxColor) {
        div2BackgroundColor = row.afterClimaxColor;
      } else if (_this.props.options.afterClimaxColor) {
        div2BackgroundColor = _this.props.options.afterClimaxColor;
      }
      if (div2Width < 10) {
        div2Width = 10;
      }
      var bar1 = {};
      var bar2 = {
        marginTop: '2px',
        marginBottom: '2px',
        marginLeft: '0px',
        marginRight: '0px',
        padding: '1.0rem 1.25rem',
        position: 'absolute',
        right: rightPadWidth,
        backgroundColor: div2BackgroundColor,
        width: div2Width,
        "float": 'left',
        height: '30px',
        borderLeft: '3px solid #997AE8',
        borderTopRightRadius: '10px',
        borderBottomRightRadius: '10px',
        boxShadow: '2px 2px 4px #000000',
        borderRadius: '4px',
        zIndex: '999'
      };
      if (_this.props.options.barStyle.shadow != null) {
        if (_this.props.options.barStyle.shadow == false) {
          bar2.boxShadow = 'none';
        } else {
          bar2.boxShadow = _this.props.options.barStyle.shadow;
        }
      }
      if (_this.props.options.barStyle.border != null) {
        bar2.border = _this.props.options.barStyle.border;
      }
      if (_this.props.options.barStyle.height != null) {
        bar2.height = _this.props.options.barStyle.height;
      }
      if (_this.props.options.barStyle.borderRadius != null) {
        bar2.borderTopLeftRadius = _this.props.options.barStyle.borderRadius;
        bar2.borderBottomLeftRadius = _this.props.options.barStyle.borderRadius;
        bar2.borderBottomRightRadius = _this.props.options.barStyle.borderRadius;
        bar2.borderTopRightRadius = _this.props.options.barStyle.borderRadius;
      }
      if (row.borderLeft != null) {
        bar2.borderLeft = row.borderLeft;
      }
      bar2.borderLeftColor = '#997AE8';
      bar2.borderLeftWidth = '3px';
      bar2.transition = '0.14s cubic-bezier(0.215, 0.61, 0.355, 1)';
      bar2.boxShadow = '0px 2px 12px rgba(0, 0, 0, 0.15)';
      return {
        bar1: bar1,
        bar2: bar2
      };
    });
    _defineProperty(_this, "onTimeLineRowClick", function (event, group) {
      event.preventDefault();
      var groups = _this.state.groups;
      groups.map(function (g_o) {
        if (g_o.id == group.id) {
          g_o.open = !g_o.open;
        }
      });
      _this.setState({
        groups: groups
      });
    });
    _defineProperty(_this, "renderMultipleBars", function (rows, group, index) {
      var timelineStyle = {
        width: '100%'
      };
      timelineStyle.position = 'relative';
      timelineStyle.display = 'block';
      var numberOfRowsInGroup = 0;
      return /*#__PURE__*/React.createElement("td", {
        style: timelineStyle,
        onClick: function onClick(e) {
          _this.onTimeLineRowClick(e, group);
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          top: '-15px',
          zIndex: '999'
        }
      }, group.showGroupTitle ? group.title : null, " ", ' ', group.showGroupTitle && group.title != null ? /*#__PURE__*/React.createElement("div", {
        className: "timeline-dropdown-button"
      }, group.showGroupTitle ? group.open ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null) : null) : null), _this.props.rows.map(function (row, index) {
        if (group.id == row.group) {
          if (row.endDate >= _this.props.options.leftBound && row.startDate <= _this.props.options.rightBound) {
            var _this$getCalculatedSt = _this.getCalculatedStyles(row),
              bar1 = _this$getCalculatedSt.bar1,
              bar2 = _this$getCalculatedSt.bar2;
            if (bar2.opacity != 0) {
              /*#__PURE__*/React.createElement("div", {
                style: {
                  display: 'block',
                  height: '0px'
                }
              });
              var widthValue = bar2.width;
              bar2.width += '%';
              bar1.width += '%';
              var rowIsOverlaying = false;
              var containerStyle = {};
              if (widthValue > 0) {
                if (group.open) {
                  containerStyle = {
                    position: 'relative'
                  };
                  bar1.top = "".concat(125 * numberOfRowsInGroup, "px");
                  bar2.top = "".concat(125 * numberOfRowsInGroup, "px");
                }
                numberOfRowsInGroup += 1;
              } else {
                containerStyle = {
                  position: 'relative'
                };
              }
              _this.props.rows.map(function (r_o) {
                if (group.id == r_o.group) {
                  if (moment(row.endDate).isBefore(moment(r_o.endDate))) {
                    rowIsOverlaying = true;
                  }
                }
              });
              if (rowIsOverlaying == true && !group.open) {
                if (numberOfRowsInGroup < 3) {
                  bar2.marginTop = 15 * (numberOfRowsInGroup - 1) + 'px';
                }
                bar2.zIndex = 99 - Math.floor(widthValue);
                if (bar2.zIndex <= 0) {
                  //Fail safe, plan should be visible and not disappear
                  bar2.zIndex = 1;
                }
              }
              var courses = null;
              if (row.planning.courses != null && row.planning.courses.length > 0) {
                courses = row.planning.courses;
              } else {
                if (row.planning.associatedMatrices != null && row.planning.associatedMatrices.length > 0) {
                  courses = [];
                  row.planning.associatedMatrices.forEach(function (matrice) {
                    if (matrice._ParagraphSet != null && matrice._ParagraphSet.length > 0) {
                      courses.push(_objectSpread(_objectSpread({}, matrice.course), {}, {
                        id: matrice.courseId
                      }));
                    }
                  });
                }
              }
              return /*#__PURE__*/React.createElement("div", {
                onClick: row.action,
                style: containerStyle,
                key: "gantt_bar-".concat(row.id)
              }, /*#__PURE__*/React.createElement("div", {
                style: bar2
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  "float": 'left',
                  width: '100%'
                }
              }, _this.props.options.barStyle.showGroupTitle ? /*#__PURE__*/React.createElement("div", {
                className: "time-line-item-titles"
              }, /*#__PURE__*/React.createElement("div", {
                className: "time-line-item-groups"
              }, widthValue > 8 && courses != null && courses.length > 0 ? /*#__PURE__*/React.createElement(ColorLabelContainer, {
                collapse: true
              }, courses.map(function (course) {
                var _int = Math.floor(Math.random() * 10 + 1);
                var text = course.title;
                text = course.year != null ? text + ' ' + course.year : text;
                return /*#__PURE__*/React.createElement(ColorLabel, {
                  key: 'planning-' + row.id + '-' + _int + course.id,
                  tooltip: text,
                  color: course.colorCode
                });
              })) : null), /*#__PURE__*/React.createElement("div", {
                className: "time-line-item-date",
                style: widthValue > 20 ? {} : {
                  display: 'none'
                }
              }, /*#__PURE__*/React.createElement(DateSpan, {
                start: row.startDate,
                end: row.endDate
              })), row.planning.status == 'PLANNING_DRAFT' && widthValue > 20 ? /*#__PURE__*/React.createElement("div", {
                className: "card-meta",
                style: {
                  marginLeft: 5,
                  height: 26
                }
              }, _this.props.translate('Draft')) : null) : null, _this.props.options.barStyle.showTitle ? /*#__PURE__*/React.createElement("h3", {
                className: "timeline-planning-title"
              }, row.title) : null)));
            }
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }));
    });
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      _this.bootstrapped = false;

      /*
      if (this.props.options.bootstrapped) {
      	this.bootstrapped = this.props.options.bootstrapped;
      }
      */

      if (_this.props.options.responsive) {
        _this.responsive = true;
      }
    });
    _defineProperty(_this, "componentDidMount", function () {
      _this.previousProps = _this.props;
      _this.drawScale();
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (_this.props.rows != nextProps.rows) {
        // prevents infinite loop
        _this.previousProps = nextProps.props;
        //this.drawScale();
      }
      _this.drawScale();
    });
    _this.state = {
      tableId: "react-gantt",
      scaleMarksCount: 99,
      scaleDrawn: false,
      groups: props.groups ? props.groups.sort(function (a, b) {
        return a.title > b.title ? 1 : a.title === b.title ? a.title > b.title ? 1 : -1 : -1;
      }) : []
    };
    return _this;
  }
  _inherits(ReactGantt, _Component);
  return _createClass(ReactGantt, [{
    key: "renderBar",
    value: function renderBar(row) {
      var _this$getCalculatedSt2 = this.getCalculatedStyles(row),
        bar1 = _this$getCalculatedSt2.bar1,
        bar2 = _this$getCalculatedSt2.bar2;
      return /*#__PURE__*/React.createElement("div", {
        onClick: row.action,
        style: {
          minHeight: '120px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: bar1
      }), /*#__PURE__*/React.createElement("div", {
        style: bar2
      }, /*#__PURE__*/React.createElement("div", {
        style: bar1
      }), this.props.options.barStyle.showTitle ? /*#__PURE__*/React.createElement("h3", null, row.title) : null));
    }
  }, {
    key: "renderRows",
    value: function renderRows() {
      var _this2 = this;
      var rows = [];
      var labelWidth = '80px';
      if (this.props.options && this.props.options.labelWidth) {
        labelWidth = this.props.options.labelWidth;
      }
      var titleStyle = {
        textAlign: 'left',
        verticalAlign: 'top',
        paddingRight: '10px'
      };
      var timelineStyle = {
        width: '100%'
      };
      if (this.props.options.showBorders !== false) {
        titleStyle.border = 'solid';
        timelineStyle.border = 'solid';
      }
      var labelStyle = {
        width: labelWidth
      };
      if (this.props.rows.length > 0) {
        if (this.state.groups != null && this.state.groups.length > 0) {
          var _loop = function _loop() {
              groupObject = _this2.state.groups[i];
              var groupId = groupObject.id;
              rowStyle = {
                cursor: 'pointer'
              };
              rowStyle.marginTop = '1em';
              rowStyle.transition = '0.55s cubic-bezier(0.215, 0.61, 0.355, 1)';
              if (groupObject.open) {
                var numberOfRowsInGroup = 0;
                _this2.props.rows.map(function (r_o) {
                  var leftBound = moment(_this2.props.options.leftBound).unix();
                  var rightBound = moment(_this2.props.options.rightBound).unix();
                  var startDate = moment(r_o.startDate).unix();
                  if (startDate < 0) {
                    startDate = 0;
                  }
                  var endDate = moment(r_o.endDate).unix();
                  if (endDate < 0) {
                    endDate = 0;
                  }
                  var inViewport = startDate >= leftBound && startDate <= rightBound || endDate >= leftBound && endDate <= rightBound;
                  var outsideViewport = startDate <= leftBound && endDate >= rightBound;
                  if ((inViewport || outsideViewport) && r_o.group == groupObject.id) {
                    numberOfRowsInGroup += 1;
                  }
                });
                rowStyle.height = "".concat(125 * numberOfRowsInGroup + 50, "px");
              } else {
                rowStyle.height = '175px';
              }
              var visibleObjects = false;
              _this2.props.rows.map(function (row, index) {
                if (groupObject.id == row.group) {
                  if (row.endDate >= _this2.props.options.leftBound && row.startDate <= _this2.props.options.rightBound) {
                    visibleObjects = true;
                  }
                }
              });
              if (visibleObjects) {
                row = /*#__PURE__*/React.createElement("tr", {
                  key: groupId + groupObject.title,
                  style: rowStyle,
                  className: "timeline-item-containers"
                }, _this2.props.options.hideFirstColumn == false ? /*#__PURE__*/React.createElement("td", {
                  style: titleStyle
                }, /*#__PURE__*/React.createElement("div", {
                  style: labelStyle
                }, groupObject.title)) : null, _this2.renderMultipleBars(_this2.props.rows, groupObject, i));
                rows.push(row);
              }
            },
            groupObject,
            rowStyle,
            row;
          // For each group we iterate the rows and if the group id matches on the row compared to the
          // "current" group id we show it, using the this.renderBar method.

          for (var i = 0; i < this.state.groups.length; i++) {
            _loop();
          }
        } else {
          // the groups object isnt passed from the parent component

          for (var i = 0; i < this.props.rows.length; i++) {
            var rowStyle = {
              cursor: 'pointer'
            };
            var rowObject = this.props.rows[i];
            var row = /*#__PURE__*/React.createElement("tr", {
              key: i,
              style: rowStyle,
              onClick: rowObject.action
            }, this.props.options.hideFirstColumn == false ? /*#__PURE__*/React.createElement("td", {
              style: titleStyle
            }, /*#__PURE__*/React.createElement("div", {
              style: labelStyle
            }, rowObject.title)) : null, /*#__PURE__*/React.createElement("td", {
              style: timelineStyle
            }, this.renderBar(rowObject)));
            rows.push(row);
          }
        }
      } else {
        var row = /*#__PURE__*/React.createElement("tr", {
          key: 0
        }, this.props.options.hideFirstColumn == false ? /*#__PURE__*/React.createElement("td", {
          style: titleStyle
        }, /*#__PURE__*/React.createElement("div", {
          style: labelStyle
        })) : null, /*#__PURE__*/React.createElement("td", {
          style: timelineStyle
        }, /*#__PURE__*/React.createElement("span", null, this.props.options.placeholder != null ? this.props.options.placeholder : 'No Data')));
        rows.push(row);
      }
      return rows;
    }
  }, {
    key: "drawScale",
    value: function drawScale() {
      var leftBound = this.props.options.leftBound;
      var rightBound = this.props.options.rightBound;
      var minutes = 0;
      var hours = 0;
      var days = 0;
      var weeks = 0;
      var months = 0;
      var years = moment(rightBound).diff(moment(leftBound), 'years');
      if (years < 2) {
        var months = moment(rightBound).diff(moment(leftBound), 'months');
        if (months < 6) {
          var days = (moment(rightBound).unix() - moment(leftBound).unix()) / 24 / 60 / 60;
          if (days < 2) {
            var hours = moment(rightBound).diff(moment(leftBound), 'hours');
            if (hours < 1) {
              var minutes = moment(rightBound).diff(moment(leftBound), 'minutes');
              this.setState({
                scale: this.calculateScale(minutes, 'minutes')
              });
            } else {
              this.setState({
                scale: this.calculateScale(hours, 'hours')
              });
            }
          } else if (days > 7) {
            var weeks = days / 7;
            this.setState({
              scale: this.calculateScale(weeks, 'weeks')
            }, function () {
              //window.dispatchEvent(new Event('resize'));
            });
          } else {
            this.setState({
              scale: this.calculateScale(days, 'days')
            }, function () {
              //window.dispatchEvent(new Event('resize'));
            });
          }
        } else {
          this.setState({
            scale: this.calculateScale(months, 'months')
          });
        }
      } else {
        this.setState({
          scale: this.calculateScale(years, 'years')
        });
      }
    }
  }, {
    key: "calculateScale",
    value: function calculateScale(count, type) {
      var options = this.props.options;
      var difference = moment(options.leftBound).unix();
      var widthByTime = moment(options.rightBound).unix() - difference;
      var scale = null;
      if (options.hideFirstColumn == true) {
        // If we dont render the first td for group names we can't query the second child since theres only one!
        // This crude statement fixes that.
        // This is a very specific statement and should only be in place to fix the error if hideFirstcolumn is set to true
        scale = document.querySelector("#".concat(this.state.tableId, " thead td:nth-child(1)"));
      } else {
        scale = document.querySelector("#".concat(this.state.tableId, " thead td:nth-child(2)"));
      }
      var widthByPixels = 0;
      if (scale != null) {
        widthByPixels = scale.offsetWidth;
      }
      var markersCount = Math.round(widthByPixels / 100);
      var unitByPixels = widthByPixels / count;
      var maxIntervalWidth = 100;
      if (options.maxIntervalWidth) {
        maxIntervalWidth = options.maxIntervalWidth;
      }
      var unitsPerInterval = 1;
      if (maxIntervalWidth > unitByPixels) {
        unitsPerInterval = Math.floor(maxIntervalWidth / unitByPixels);
      }
      var intervalByPixels = unitsPerInterval * unitByPixels;
      var markersCount = Math.floor(widthByPixels / intervalByPixels) + 1;
      if (markersCount > 4) {
        // Fail safe, no more than 4 weeks. Add one week to markerscount since we start  from Monday first week and end last sunday after 3 weeks
        markersCount = 4;
      } else if (markersCount < 4) {
        // Fail safe, we need 4 weeks totalt
        markersCount = 4;
      }
      var intervalByPercent = intervalByPixels / widthByPixels * 100;
      var markers = [];
      var style = {
        margin: '0px',
        padding: '0px',
        width: '25%',
        "float": 'left',
        borderLeft: 'none',
        borderWidth: '0px',
        paddingLeft: '10px',
        fontWeight: '400',
        textTransform: 'uppercase',
        fontSize: '0.75em',
        lineHeight: '35px',
        color: '#3A3A3A'
      };
      if (options.labelBorderColor != null) {
        style.borderColor = options.labelBorderColor;
      }
      for (var i = 0; i < markersCount; i++) {
        var date = moment(difference * 1000);
        var formattedInterval, formattedCurrentDate;
        var currentDate = moment();
        switch (type) {
          case 'years':
            date.add(i * unitsPerInterval, 'years');
            formattedInterval = date.format('YYYY MM DD');
            break;
          case 'months':
            date.add(i * unitsPerInterval, 'months');
            formattedInterval = date.format('YYYY MM DD');
            break;
          case 'weeks':
            date.add(i * unitsPerInterval, 'weeks');
            formattedInterval = date.format('YYYY MM DD');
            break;
          case 'days':
            date.add(i * unitsPerInterval, 'days');
            formattedInterval = date.format('YYYY MM DD');
            break;
          case 'hours':
            date.add(i * unitsPerInterval, 'hours');
            formattedInterval = date.format('H:mm');
          case 'minutes':
            date.add(i * unitsPerInterval, 'minutes');
            formattedInterval = date.format('H:mm:ss');
          default:
        }
        if (options && options.intervalFormat) {
          formattedInterval = date.format(options.intervalFormat);
          formattedCurrentDate = currentDate.format(options.intervalFormat);
        }
        var mark = /*#__PURE__*/React.createElement("div", {
          key: i,
          style: style
        }, /*#__PURE__*/React.createElement("span", {
          className: formattedCurrentDate == formattedInterval ? 'current-column' : null
        }, "".concat(this.props.weekTranslation, " ").concat(formattedInterval)));
        markers.push(mark);
      }
      return /*#__PURE__*/React.createElement("div", null, markers);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var tableStyle = {
        width: '100%',
        overflow: 'hidden'
      };
      var scaleStyle = {
        width: '100%',
        paddingBottom: '2em'
      };
      var popoverStyle = {
        position: 'absolute',
        display: 'none'
      };
      return /*#__PURE__*/React.createElement("div", {
        id: this.state.tableId,
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("table", {
        style: tableStyle,
        className: "table table-striped table-bordered table-condensed table-hover"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, this.props.options.hideFirstColumn == false ? /*#__PURE__*/React.createElement("td", null) : null, /*#__PURE__*/React.createElement("td", {
        style: scaleStyle
      }, this.state.scale))), /*#__PURE__*/React.createElement("tbody", null, this.renderRows())), /*#__PURE__*/React.createElement("div", {
        className: "lines"
      }, /*#__PURE__*/React.createElement("div", {
        className: "line"
      }), /*#__PURE__*/React.createElement("div", {
        className: "line"
      }), /*#__PURE__*/React.createElement("div", {
        className: "line"
      }), /*#__PURE__*/React.createElement("div", {
        className: "line"
      })), /*#__PURE__*/React.createElement(ResizeObserver, {
        onResize: function onResize() {
          _this3.drawScale();
        }
      }));
    }
  }]);
}(Component);
ReactGantt.propTypes = {
  groups: PropTypes.array,
  options: PropTypes.object,
  rows: PropTypes.array
};
ReactGantt.defaultProps = {
  groups: {},
  options: {},
  rows: {}
};
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, null, null, {
  pure: false
})(ReactGantt);